import { WSS_HOST, WSS_PATH } from '../const';
import { BaseClient } from './base';
export class EditorClient extends BaseClient {
    socketInitCallback = [];
    constructor() {
        super(WSS_HOST, WSS_PATH.editor);
    }
    onSocketInit(socket) {
        this.socketInitCallback.forEach(callback => {
            callback(socket);
        });
    }
    registerSocketInitEvent(callback) {
        this.socketInitCallback.push(callback);
        if (this.socket.connected) {
            callback(this.socket);
        }
    }
}
